import React from "react";
import Aboutfryright from "./New-Fry-Right-Components/Aboutfryright";
import Benefits from "./New-Fry-Right-Components/Benefits";
import EndFryRight from "./New-Fry-Right-Components/EndFryRight";
import Fryrightfooter from "./New-Fry-Right-Components/Fryrightfooter";
import HealthfryRight from "./New-Fry-Right-Components/HealthfryRight";
import Newfryrightbaner from "./New-Fry-Right-Components/Newfryrightbaner";

const NewFryRightSystem = () => {
  return (
    <div className="fryrightSystem-container">
      <Newfryrightbaner />
      <Aboutfryright />
      <Benefits />
      <HealthfryRight />
      <EndFryRight />
      <Fryrightfooter />
    </div>
  );
};

export default NewFryRightSystem;
